import { __generator } from "tslib";
import { all, takeEvery, call, put } from 'redux-saga/effects';
import { request, isApiError } from '../../xhr';
import { watchTopic, watchTopicSuccess, watchTopicFailure, unwatchTopic, unwatchTopicSuccess, unwatchTopicFailure, suppressTopic, suppressTopicSuccess, suppressTopicFailure, } from './actions';
export function handleWatchTopic(_a) {
    var necoid, _b, suggested_neco_id_lists, source, result;
    var _c = _a.payload, params = _c.params, onSuccess = _c.onSuccess;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                necoid = params.necoid, _b = params.suggested_neco_id_lists, suggested_neco_id_lists = _b === void 0 ? [] : _b, source = params.source;
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/topic/watch',
                        data: {
                            necoid: necoid,
                            suggested_neco_id_lists: JSON.stringify(suggested_neco_id_lists),
                            source: source,
                        },
                    })];
            case 1:
                result = _d.sent();
                if (!(!result || isApiError(result))) return [3 /*break*/, 3];
                return [4 /*yield*/, put(watchTopicFailure(params))];
            case 2:
                _d.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(watchTopicSuccess(params, result))];
            case 4:
                _d.sent();
                onSuccess && onSuccess(result);
                _d.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export function handleUnwatchTopic(_a) {
    var result;
    var _b = _a.payload, params = _b.params, onSuccess = _b.onSuccess;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/topic/unwatch',
                    data: params,
                })];
            case 1:
                result = _c.sent();
                if (!(!result || isApiError(result))) return [3 /*break*/, 3];
                return [4 /*yield*/, put(unwatchTopicFailure(params))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(unwatchTopicSuccess(params, result))];
            case 4:
                _c.sent();
                onSuccess && onSuccess(result);
                _c.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export function handleSuppressTopic(_a) {
    var result;
    var _b = _a.payload, params = _b.params, onSuccess = _b.onSuccess;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/topic/suppress',
                    data: params,
                })];
            case 1:
                result = _c.sent();
                if (!(!result || isApiError(result))) return [3 /*break*/, 3];
                return [4 /*yield*/, put(suppressTopicFailure(params))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(suppressTopicSuccess(params, result))];
            case 4:
                _c.sent();
                onSuccess && onSuccess(result);
                _c.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(watchTopic, handleWatchTopic),
                    takeEvery(unwatchTopic, handleUnwatchTopic),
                    takeEvery(suppressTopic, handleSuppressTopic),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map